import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/peopleLivelihood",
  name: "peopleLivelihood",
  redirect: {
    name: "list",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "list",
      name: "list",
      meta: {
        ...meta,
        title: "实事列表",
        cache: true,
      },
      component: () => import("@/pages/peopleLivelihood/index.vue"),
    },
    {
      path: "statistics",
      name: "statistics",
      meta: {
        ...meta,
        title: "统计报表",
      },
      component: () => import("@/pages/peopleLivelihood/statistics.vue"),
    },
    {
      path: "report",
      name: "report",
      meta: {
        ...meta,
        title: "民生微实事备案",
      },
      component: () => import("@/pages/peopleLivelihood/report.vue"),
    },
  ],
};
